var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToday(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.46089 6.03732C3.46084 6.03729 3.46209 6.03673 3.46478 6.03573C3.46229 6.03685 3.46095 6.03735 3.46089 6.03732ZM3.75 6V9.75H20.25V6H3.75ZM20.5391 6.03732C20.5391 6.03735 20.5377 6.03685 20.5352 6.03573C20.5379 6.03673 20.5392 6.03729 20.5391 6.03732ZM20.5391 9.71268C20.5391 9.71272 20.5379 9.71328 20.5352 9.71427C20.5377 9.71314 20.5391 9.71264 20.5391 9.71268ZM3.46089 9.71268C3.46095 9.71265 3.46229 9.71315 3.46478 9.71427C3.46209 9.71327 3.46084 9.71271 3.46089 9.71268ZM2.97191 4.61899C3.20643 4.53691 3.48156 4.5 3.75 4.5H20.25C20.5184 4.5 20.7936 4.53691 21.0281 4.61899C21.1419 4.65882 21.2874 4.72347 21.4192 4.8325C21.5462 4.93758 21.75 5.16356 21.75 5.5125V10.2375C21.75 10.5864 21.5462 10.8124 21.4192 10.9175C21.2874 11.0265 21.1419 11.0912 21.0281 11.131C20.7936 11.2131 20.5184 11.25 20.25 11.25H3.75C3.48156 11.25 3.20643 11.2131 2.97191 11.131C2.85811 11.0912 2.71256 11.0265 2.58079 10.9175C2.4538 10.8124 2.25 10.5864 2.25 10.2375V5.5125C2.25 5.16356 2.4538 4.93758 2.58079 4.8325C2.71256 4.72347 2.85811 4.65882 2.97191 4.61899Z",
    fill: "#6F6F6F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25 15C2.25 14.5858 2.58579 14.25 3 14.25H21C21.4142 14.25 21.75 14.5858 21.75 15C21.75 15.4142 21.4142 15.75 21 15.75H3C2.58579 15.75 2.25 15.4142 2.25 15Z",
    fill: "#6F6F6F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25 19.5C2.25 19.0858 2.58579 18.75 3 18.75H21C21.4142 18.75 21.75 19.0858 21.75 19.5C21.75 19.9142 21.4142 20.25 21 20.25H3C2.58579 20.25 2.25 19.9142 2.25 19.5Z",
    fill: "#6F6F6F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToday);
export default __webpack_public_path__ + "static/media/Today.58ed49ab5e1815f5e423e388fec25938.svg";
export { ForwardRef as ReactComponent };